import BreadCrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import Modal from "../../common/Modal";
import AddUpdate from "./addUpdate";
import RestaurantList from "./restaurantList";
import Table from "../../common/table";
import ReactTooltip from "react-tooltip";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import Icon from "../../icons/index";
import swal from "sweetalert2";
import { useStore } from "../../../zustand/store";
import qs from "qs";
import CS from "../../../services/commonService";
import SingleStatusToggle from "../../common/singleStatusToggle";
import React, { useState, useEffect } from "react";
import {
	usedeleteCoupons,
	usegetAllCoupons,
	useupdateCoupons,
} from "../../../queryHooks/useCoupons";
import { pageToLoadOnDelete } from "../../../helpers";

//	Pre-defined values
const statusOptions = [
	{ value: true, label: "Active" },
	{ value: false, label: "Inactive" },
];

const featuredOptions = [
	{ value: true, label: "Yes" },
	{ value: false, label: "No" },
];

const columnKey = "coupons";
//	Component starts
const Coupons = () => {
	//	State values
	const [coupon, setCoupon] = useState({});
	const [open, setOpen] = useState(false);
	const [restaurantList, setRestaurantList] = useState([]);
	const [restaurantModal, setRestaurantModal] = useState(false);
	const [tableData, setTableData] = useState([]);
	const setLoading = useStore((state) => state.setLoading);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [pageNow, setPageNow] = useState(1);
	const [couponsPayload, setCouponsPayload] = useState({
		pagination: true,
		items_per_page: itemsPerPage,
		page: pageNow,
		sort: { created_at: "DESC" },
	});

	const {
		data: dataGetCoupons,
		isLoading,
		refetch,
	} = usegetAllCoupons(qs.stringify(couponsPayload));

	useEffect(() => {
		if (dataGetCoupons && dataGetCoupons?.status === "success") {
			let respData = dataGetCoupons?.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetCoupons]);

	const {
		mutateAsync: updateCoupons,
		error: errorUpdateCoupons,
		data: dataUpdateCoupons,
	} = useupdateCoupons();

	useEffect(() => {
		if (dataUpdateCoupons) {
			setLoading(false);
			if (dataUpdateCoupons?.status === "success") {
				CS.showSuccessMessage("Status updated successfully");
				refetch();
			} else if (dataUpdateCoupons?.status === "fail") {
				CS.showErrorMessage(dataUpdateCoupons?.message);
			}
		}
	}, [dataUpdateCoupons]);

	useEffect(() => {
		if (errorUpdateCoupons) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateCoupons?.response?.data?.message);
		}
	}, [errorUpdateCoupons]);

	const {
		mutateAsync: deleteCoupons,
		error: errorDeleteCoupons,
		data: dataDeleteCoupons,
	} = usedeleteCoupons();

	useEffect(() => {
		if (dataDeleteCoupons) {
			setLoading(false);
			if (dataDeleteCoupons.status === "success") {
				let _page = pageToLoadOnDelete(
					tableData?.total_items,
					1,
					pageNow,
					itemsPerPage
				);
				if (_page === pageNow) refetch();
				setPageNow(_page);
				setCouponsPayload({ ...couponsPayload, page: _page });
				CS.showSuccessMessage(dataDeleteCoupons?.message);
			} else if (dataDeleteCoupons?.status === "fail") {
				CS.showErrorMessage(dataDeleteCoupons?.message);
			}
		}
	}, [dataDeleteCoupons]);

	useEffect(() => {
		if (errorDeleteCoupons) {
			setLoading(false);
			CS.showErrorMessage(errorDeleteCoupons?.response?.data?.message);
		}
	}, [errorDeleteCoupons]);

	const closeModal = () => {
		setCoupon({});
		setOpen(false);
	};

	const closeRestaurantModal = () => {
		setRestaurantModal(false);
		setTimeout(() => {
			setRestaurantList([]);
		}, 1000);
	};

	const columns = [
		{
			label: "Coupon code",
			type: "string",
			sort: true,
			path: "code",
			alias: "code",
		},
		{
			label: "Start Date",
			type: "date",
			path: "start_date",
			filterDate: true,
			alias: "start_date",
			content: (item) => getCurrentTimezoneDate(item?.start_date),
		},
		{
			label: "End Date",
			type: "date",
			path: "end_date",
			filterDate: true,
			alias: "end_date",
			content: (item) => getCurrentTimezoneDate(item?.end_date),
		},

		{
			label: "Featured",
			type: "boolean",
			path: "is_featured",
			filterOptions: featuredOptions,
			aliasFilter: "is_featured",
			content: (item) => (
				<SingleStatusToggle
					_id={item?.id}
					status={item?.is_featured}
					onToggleChange={() => {
						updateCoupons({
							id: item?.id,
							body: {
								is_featured: item?.is_featured === 0 ? true : false,
							},
						});
						setLoading(true);
					}}
					htmlFor={item?.id}
				/>
			),
		},
		{
			label: "Status",
			type: "boolean",
			filterOptions: statusOptions,
			path: "is_active",
			aliasFilter: "is_active",
			content: (item) => (
				<SingleStatusToggle
					_id={`${item?.id}${item?.is_active}`}
					status={item.is_active}
					onToggleChange={() => {
						updateCoupons({
							id: item?.id,
							body: {
								is_active: item?.is_active === 0 ? true : false,
							},
						});
						setLoading(true);
					}}
					htmlFor={`${item?.id}${item?.is_active}`}
				/>
			),
		},
		{
			label: "Restaurants",
			type: "string",
			path: "restaurants",
			alias: "restaurants",
			content: (item) => (
				<div style={{ textAlign: "center" }}>
					<p
						onClick={() => {
							if (item.used_at != 0) {
								setCoupon(item);
								setRestaurantModal(true);
							}
						}}
						style={{ cursor: "pointer" }}
					>
						{item?.used_at > 0 ? item?.used_at : "All"}
					</p>
				</div>
			),
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="edit"
						data-tip
						data-for="edit"
						onClick={() => {
							setOpen(true);
							setCoupon(item);
						}}
					/>
					<ReactTooltip id="edit" place="top" effect="solid">
						Edit
					</ReactTooltip>
					<Icon
						type="delete"
						data-tip
						data-for="delete"
						onClick={() =>
							swal
								.fire({
									title: "Are you sure you want to delete?",
									icon: "warning",
									showCancelButton: true,
									confirmButtonColor: "#3085d6",
									cancelButtonColor: "#d33",
									confirmButtonText: "Yes, delete it!",
								})
								.then((result) => {
									if (result.isConfirmed) {
										deleteCoupons(item?.id);
										setLoading(true);
									}
								})
						}
					/>
					<ReactTooltip id="delete" place="top" effect="solid">
						Delete
					</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<BreadCrumbs title="Master Management" data={[{ label: "Coupons" }]} />
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												search={(value) => {
													setPageNow(1);
													setCouponsPayload({
														...couponsPayload,
														search: {
															code: !value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="right-buttons d-flex justify-content-end">
											<button
												onClick={() => setOpen(true)}
												id="addNewCoupon"
												type="button"
												className="btn glow-primary btn-primary"
											>
												<i className="bx bx-user-plus d-lg-none" />
												<span className="d-none d-sm-none d-lg-inline-block">
													Add Coupon
												</span>
											</button>
										</div>
									</div>
								</div>
							</div>
							<Modal open={open} onCloseModal={closeModal}>
								<AddUpdate
									coupon={coupon}
									columnKey={columnKey}
									onCloseModal={closeModal}
									refetch={refetch}
								/>
							</Modal>
							<Modal open={restaurantModal} onCloseModal={closeRestaurantModal}>
								<RestaurantList
									coupon={coupon}
									columnKey={columnKey}
									onCloseModal={closeRestaurantModal}
									refetch={refetch}
								/>
							</Modal>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setCouponsPayload({
										...couponsPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setCouponsPayload({
										...couponsPayload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setCouponsPayload({
										...couponsPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(
											couponsPayload.filter,
											obj
										);
										setPageNow(1);
										setCouponsPayload({
											...couponsPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setCouponsPayload({
											...couponsPayload,
											filter: {
												...couponsPayload.filter,
												[obj.alias]: String(obj.filter),
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setCouponsPayload({
										...couponsPayload,
										filter_date: dates && {
											...couponsPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Coupons;
